import { ThemeProvider, CssBaseline, Box } from "@mui/material";
import * as React from "react";
import { theme } from "components/mnl/global/theme";
import MenuBar from "components/mnl/global/menuBar";
import GetAllTestOrder from "components/mnl/admin/testOrder/getAllTestOrder";
import V2sessionTimeout from "components/mnl/global/v2SessionTimeout";
import TableLayout from "views/mnl/layout/tableLayout";

const TestOrderPage = () => {
  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ display: "flex" }}>
        <CssBaseline />
        <MenuBar pageName={"Test Order"} />
        <TableLayout>
          <GetAllTestOrder />
        </TableLayout>
      </Box>
      <V2sessionTimeout />
    </ThemeProvider>
  );
};
export default TestOrderPage;
